<template lang="pug">
    div
        div(style="width:350px; border0px solid;")
            h4(style="display:inline-block; width:80px; border:0px solid;") Stock
            StockSelector(@setStock="setStock" :parentStock="selectedStock" :account="getCompetitionAccount" style="display:inline-block; width:265px; border:0px solid;")
        div(v-if="selectedStock" style="width:350px; border:0px solid;")
            v-row(no-gutters style="border:0px solid;")
                v-col(cols="12" style="border:0px solid;")
                    span(class="title mb-1 mr-2" style="display:inline-block; width:80px; border:0px solid;") {{$t('price')}}:
                    span(v-if="selectedStock.currency_trade === 'SEK'" class="text") {{selectedStock.price_today.toFixed(2)}} {{selectedStock.currency_trade}}
                    span(v-else class="text") {{selectedStock.price_today.toFixed(2)}} {{selectedStock.currency_trade}} = {{getConvertedPrice.toFixed(2)}} SEK

                v-col(v-if="action === 'SELL'" cols="12")
                    span(class="title mb-1 mr-1") {{$t('in_my_positions')}}:
                    span(class="text") {{getNumberOfOwnedStock(user_account_id, selectedStock.stock_id)}}

                v-col(cols="12")
                    div
                        p(class="title" style="display:inline-block; width:80px; border:0px solid;") {{$t('quantity')}}
                        v-text-field(label="Quantity" type="number" dense solo v-model="quantity" style="display:inline-block; width:265px;")

                v-col(cols="12")
                    div
                        p(class="title" style="display:inline-block; width:80px; border:0px solid;") {{action === 'SELL' ? $t('total_sell_price') : $t('total_buy_price')}}
                        p(style="display:inline-block;") {{ (getConvertedPrice * quantity).toFixed(2) }} SEK

                v-col(cols="12" class="text-right" style="border:0px solid;")
                    v-btn(
                        color="blue3"
                        class="white--text"
                        @click="submitOrder()"
                        :disabled="disabledOrderBtn(action)"
                    ) {{action === 'SELL' ? $t('submit_sell_order') : $t('submit_buy_order')}}
</template>

<script>
import StockSelector from "./StockSelector";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
    name: "BrokerActionBox",
    components: {
        StockSelector,
    },
    props: ["action", "user_id", "user_account_id"],
    data() {
        return {
            selectedStock: null,
            quantity: null,
            exchangeRate: [],
        };
    },
    async mounted() {
        await this.loadTxOrders(this.competition_user_account_id);
    },
    computed: {
        ...mapGetters([
            "getNumberOfOwnedStock",
            "getExchangeRates",
            "getUserAccounts",
            "getTxOrders",
            "getAllStocks",
            "getUserTrades"
        ]),
        getConvertedPrice() {
            if (this.selectedStock.currency_trade === 'SEK') {
                return this.selectedStock.price_today;
            }

            const currency = this.selectedStock.currency_trade;
            const exchange = this.getExchangeRates.find((e) => e.symbol === currency);
            const rate = exchange.rate;
            const convertedPrice = this.selectedStock.price_today / rate;

            if (!convertedPrice) {
                throw new Error(`Failed to getConvertedPrice : currency ${currency} exchange: ${exchange} rate: ${rate}, price_today: ${convertedPrice}`);
            }
            return convertedPrice;
        },
        competition_id() {
            return (this.$route.params.competition_id !== undefined) ? Number(this.$route.params.competition_id) : -1;
        },
        competition_user_account_id() {
            return this.competition_id !== -1 ? this.getUserAccounts.find((a) => a.competition_id === this.competition_id).user_account_id : -1;
        },
        exchangeRates() {
            return this.getExchangeRates;
        },
        getCompetitionAccount() {
            return this.getUserAccounts.find((a) => a.user_account_id === this.competition_user_account_id);
        },
        availableCash() {
            const sumAmountSek = _.sumBy(this.getTxOrders, (o) => o.amount_sek);
            const cash = this.getCompetitionAccount.cash;
            const availableCash = cash - sumAmountSek;

            return availableCash;
        },
        disabledOrderBtn: (state) => (action) => {
            if (action === "SELL") {
                if (
                    !state.selectedStock.price_today ||
                    !state.quantity ||
                    state.quantity <= 0 ||
                    state.getNumberOfOwnedStock(
                        state.user_account_id,
                        state.selectedStock.stock_id
                    ) < state.quantity
                ) {
                    return true;
                } else {
                    return false;
                }
            }
            if (action === "BUY") {
                if (
                    !state.selectedStock.price_today ||
                    !state.quantity ||
                    state.quantity <= 0
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        },
    },
    methods: {
        ...mapActions([
            "loadTrades",
            "loadUserAccounts",
            "loadCreateTransaction",
            "loadTx",
            "loadTxOrders",
            "insertTxOrder"
        ]),
        setStock(stock) {
            this.selectedStock = stock;
            this.quantity = null;
        },
        async submitOrder() {
            const user_id = this.user_id;
            const account = this.getCompetitionAccount;
            const user_account_id = account.user_account_id;

            await this.loadTx(user_id);
            await this.loadTrades(user_id);
            await this.loadTxOrders(user_account_id);

            const stock_id = parseInt(this.selectedStock.stock_id);
            const qty = parseInt(this.quantity);
            const amount_sek = this.getConvertedPrice * this.quantity;
            const commission = 0;
            const currency = this.getAllStocks.find((s) => s.stock_id === stock_id).currency_trade;
            const exchange_rate = 1;
            const price = this.getAllStocks.find((s) => s.stock_id === stock_id).price_today;
            const tx_type = this.action;
            const tx_datetime = moment().format('YYYY-MM-DD HH:mm:ss');

            const tradeStockSum = this.getNumberOfOwnedStock(user_account_id, stock_id);

            const ordersOnStock = this.getTxOrders.filter((o) => o.stock_id === stock_id);
            const ordersOnStockSum = _.sumBy(ordersOnStock, (o) => o.qty);

            const quantityAvailable = tradeStockSum - ordersOnStockSum;
            const quantityAvailableToOrderCheck = quantityAvailable - qty;

            if(this.availableCash < amount_sek && tx_type === 'BUY') {
                this.$store.commit('setMessage', { text: "Not enough with funds", type: 'error' });
                return;
            } else if(quantityAvailableToOrderCheck < 0 && tx_type === 'SELL') {
                this.$store.commit('setMessage', { text: "Not enough quantity to make order on selected stock", type: 'error' });
                return;
            }

             const orderObject = {
                user_id,
                amount_sek,
                commission,
                currency,
                exchange_rate,
                price,
                qty,
                stock_id,
                tx_datetime,
                tx_type,
                user_account_id
            };

            console.log(orderObject);

            await this.insertTxOrder(orderObject);

            this.selectedStock = null;
            this.quantity = null;

            this.$store.commit('setMessage', {
                text: "Successful Transaction",
                type: 'success'
            });
        }
    }
};
</script>

<style scoped>
.title {
    font-weight: 700 !important;
    margin: 0;
}

.text {
    font-size: 1.2rem !important;
}
</style>
